<template>
  <lb-drawer
    :value="value"
    :Maxwidth="uploadData.length > 0 ? '1665' : '700'"
    heading="Bulk Upload Information Requests"
    :loading="loading"
    @input="$emit('input', $event)"
  >
    <template v-slot:body>
      <div>
        <v-simple-table
          v-if="uploadData.length > 0"
          class="radius-small border-on simple-table"
        >
          <template v-slot:default>
            <thead class="grayBackground">
              <th class="text-left text-capitalize pa-2 border-right-data grayBackground">Errors</th>
              <th
                v-for="(header, index) in headers"
                :key="index"
                class="text-left text-capitalize pa-2 grayBackground"
                :class="index < headers.length - 1 ? 'border-right-data' : 'border-on'"
              >
                {{ header }}
              </th>
            </thead>
            <v-slide-y-transition group tag="tbody" style="overflow:hidden !important;">
              <tr v-for="(row, rowIndex) in uploadData" :key="rowIndex">
                <td class="error--text">
                  <div v-if="row.data[0].errors && row.data[0].errors.length > 0" class="pa-2 text-error">
                    {{ row.data[0].errors }}
                  </div>
                  <span v-else class="gray--text">No errors</span>
                </td>
                <td>
                  <v-chip
                    v-for="(tag, tagIndex) in ((row.data[0] || {}).ref || [])"
                    :key="tagIndex"
                    label
                    color="lightpurple"
                    class="caccounting--text pl-0 mb-1 mr-1"
                  >
                    <span class="pl-1">{{ tag }}</span>
                  </v-chip>
                </td>
                <td>{{ (row.data[0] || {}).category || 'Others' }}</td>
                <td>{{ (row.data[0] || {}).description }}</td>
                <td>{{ (row.data[0] || {}).info_owner_name }}</td>
                <td>{{ (row.data[0] || {}).info_owner_email }}</td>
                <td>
                  <div v-if="(row.data[0] || {}).file_upload !== fileUploadFlag">Text</div>
                  <div v-else>File Upload</div>
                </td>
                <td>{{ (row.data[0] || {}).uploadlink }}</td>
                <td>{{ (row.data[0] || {}).priority || 'Medium' }}</td>
                <td>{{ (row.data[0] || {}).duedate }}</td>
                <td>{{ (row.data[0] || {}).location }}</td>
              </tr>
            </v-slide-y-transition>
          </template>
        </v-simple-table>
        <div class="ml-2 error--text mt-2 mr-2" v-if="errorFlag">
          We found a few errors. Rectify these errors to proceed to upload
        </div>
        <v-chip
          v-for="(item, index) in errorList"
          :key="index"
          label
          color=""
          class="error--text pl-0 mb-1 mr-1"
        >
          <span class="pl-1">{{ item }}</span>
        </v-chip>
      </div>
    </template>

    <template v-slot:actions>
      <v-btn
        v-if="!errorFlag"
        class="ml-2 white--text"
        color="primary"
        @click="$emit('verify-upload')"
      >
        <span>Verify &amp; Upload</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'ProjectBulkUploadDrawer',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    uploadData: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errorFlag: {
      type: Boolean,
      default: false,
    },
    errorList: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    fileUploadFlag: {
      type: String,
      default: 'fileupload',
    },
  },
};
</script>
